'use client';

import { webRunnerRequestDataAdapter } from './useWebRunnerRequestDataAdapter';
import { useDaemonTriggerModal as useSharedDaemonTriggerModal } from '@agentteams/runner-request/ui/hooks/useDaemonTriggerModal';

export {
  extractQuestionsForUser,
  extractQuestionsForUserMarkdown,
  findSelectedDiscoveredWorktree,
  getAvailableModelsForDaemon,
  getBranchFailureReason,
  getCompatibleAgentConfigsForDaemon,
  getDiscoveredWorktreeOptionLabel,
  getModelsForRunnerContext,
  getQuestionsForUserMarkdown,
  getSupportedRunnerTypesForDaemon,
  isActiveDaemonTriggerStatus,
  isAgentConfigCompatibleWithDaemon,
  isDaemonTriggerSelectableAgentConfig,
  scopeAgentConfigsToSelectedDaemon,
  scopeDiscoveredWorktreesToSelectedDaemon,
  shouldFallbackToManualBranchInput,
  toDiscoveredWorktreeOptionValue,
} from '@agentteams/runner-request/ui/hooks/useDaemonTriggerModal';
export type { BranchFailureReason, BranchInputMode } from '@agentteams/runner-request/ui/hooks/useDaemonTriggerModal';

type SharedArgs = Parameters<typeof useSharedDaemonTriggerModal>[0];

/**
 * 웹 기본 어댑터를 바인딩한 러너 요청 모달 훅. 상태·전이 로직은 공용 패키지가 소유하고,
 * 이 모듈은 웹 데이터 어댑터 기본값과 기존 import 경로만 유지한다.
 */
export const useDaemonTriggerModal = ({
  adapter = webRunnerRequestDataAdapter,
  ...rest
}: Omit<SharedArgs, 'adapter'> & { adapter?: SharedArgs['adapter'] }) =>
  useSharedDaemonTriggerModal({ ...rest, adapter });
